import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  fetchAllSeasonData,
  resetVideoLibraryInitialState,
} from "../../../Redux/Actions/VideoLibraryActions";
import EventList from "./EventList";
import OtherSeasonEvents from "./OtherSeasonEvents";
import PracticeList from "./PracticeList";
import SeasonList from "./SeasonList";
import SelectClips from "./SelectClips";
import WeekList from "./WeekList";
import OffSeasonEventList from "./OffSeasonEventsList";
import { CircularProgress } from "@mui/material";

const PastSeason = () => {
  const dispatch = useDispatch();
  const [activeSeason, setActiveSeason] = useState(null);
  const [activeEventType, setActiveEventType] = useState(null);
  const [activeOffSeasonEvent, setActiveOffSeasonEvent] = useState(null);
  const [activePractice, setActivePractice] = useState(null);
  const [activeOtherSeasonEvent, setActiveOtherSeasonEvent] = useState(null);
  const [expanded, setExpanded] = useState(null);
  const [activeEventTypeOfWeek, setActiveEventTypeOfWeek] = useState(null);
  const [selectedVideos, setSelectedVideos] = useState([]);

  const schoolId = useSelector((state) => state.loggedInUser.school.id);
  const currentSeason = useSelector(
    (state) => state?.loggedInUser?.userProfile?.currentSeason?.years
  );
  const fetchedSeasonData = useSelector(
    (state) =>
      state?.videoLibraryData?.fetchedSeasonData?.allSeasonData?.filter(
        (data) => data.seasonName !== currentSeason
      ),
    shallowEqual
  );
  const isLoading = useSelector(
    (state) => state.videoLibraryData.fetchedSeasonData?.loading
  );
  useEffect(() => {
    fetchAllSeasonData(dispatch, schoolId);
    return () => {
      resetVideoLibraryInitialState(dispatch, {});
    };
  }, []);
  return (
    <>
      {isLoading ? (
        <div className="d-flex-center">
          <div className="content-layout-loading-animation">
            <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
              <CircularProgress
                className="rounded-circle"
                color="success"
                sx={{ fontSize: 10, color: "#002244" }}
                disableShrink
              />
            </div>
          </div>
        </div>
      ) : fetchedSeasonData?.length > 0 ? (
        <>
          <h4 className="fs-24 bold mob-hd mg-bottom-10">Past Seasons</h4>
          <div className="d-flex flex-direction-r gap-10 mg-bottom-10 padding-5 overflow-auto">
            <SeasonList
              active={activeSeason}
              setActive={setActiveSeason}
              setActiveEventType={setActiveEventType}
              setSelectedVideos={setSelectedVideos}
            />
            <EventList
              active={activeEventType}
              setActive={setActiveEventType}
              setActiveOffSeasonEvent={setActiveOffSeasonEvent}
              setActiveOtherSeasonEvent={setActiveOtherSeasonEvent}
              setActiveEventTypeOfWeek={setActiveEventTypeOfWeek}
              setExpanded={setExpanded}
              setSelectedVideos={setSelectedVideos}
            />
            <WeekList
              active={activeEventTypeOfWeek}
              setActive={setActiveEventTypeOfWeek}
              expanded={expanded}
              setExpanded={setExpanded}
              setSelectedVideos={setSelectedVideos}
            />
            <OtherSeasonEvents
              active={activeOtherSeasonEvent}
              setActive={setActiveOtherSeasonEvent}
              setSelectedVideos={setSelectedVideos}
            />
            <OffSeasonEventList
              active={activeOffSeasonEvent}
              setActive={setActiveOffSeasonEvent}
              setActivePractice={setActivePractice}
              setSelectedVideos={setSelectedVideos}
            />
            <PracticeList
              active={activePractice}
              setActive={setActivePractice}
              setSelectedVideos={setSelectedVideos}
            />
            <SelectClips
              selectedVideos={selectedVideos}
              setSelectedVideos={setSelectedVideos}
            />
          </div>
        </>
      ) : (
        <div className="d-flex-center">
          <p className="mg-top-150">No Season Found With Uploaded Video</p>
        </div>
      )}
    </>
  );
};

export default PastSeason;
